module.exports = __webpack_public_path__ + "static/media/lock-open.c0fc38bd.svg";